<template>
  <div class="page-wrapper" style="position: fixed; top:0; left:0; width: 100%; height: 100%; padding-top:0; color: #555; overflow-y: auto;">
    <template v-if="merchantItem !== false">
      <div style="width: 100%; height: 300px; position: relative; background-repeat: no-repeat; background-position: center; background-size: cover;"
           id="home">
        <!--             v-bind:style="{backgroundImage: 'url(' + merchantItem.webSetting.imageUrls.split(',')[0] +')'}"-->



        <slider animation="fade" style="height:100%">
          <slider-item
            v-for="(img, index) in merchantItem.webSetting.imageUrls"
            :key="index"
            style="z-index: 0; height:100%;"


          >
            <div class="restaurant-main-image" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
          </slider-item>
        </slider>

        <div style="position: absolute; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.2);">
          <div style="width: 100%; text-align: center; color: white;font-size: 30px; line-height: 55px; font-weight: bold; text-shadow: 2px 2px 8px gray; padding-top:30px;">{{merchantItem.webSetting.topMessage}}</div>
          <div v-if="merchantItem.webSetting.topMessageSmall !== null && merchantItem.webSetting.topMessageSmall.length >0" style="width: 100%; text-align: center; color: white;font-size: 15px; line-height: 40px; font-weight: bold; text-shadow: 2px 2px 8px gray;">{{merchantItem.webSetting.topMessageSmall}}</div>
<!--          <div style="width: 100%; text-align: center; padding-top: 30px;">-->
<!--            <a :href="'/order/' + merchantItem.merchantId + '/takeaway'"><span style="padding:10px; background-color: white; color:black; box-shadow: 3px 3px 20px grey;">Online Order</span></a>-->
<!--          </div>-->
        </div>
      </div>
      <div class="web-section gray-section">
        <div class="container">
        <template v-if="bookingType === 0">
        <booking-view
          :merchant-item="merchantItem">

        </booking-view>
        </template>
        <template v-else-if="bookingType === 1">
        <booking-table-view
          :merchant-item="merchantItem">

        </booking-table-view>

        </template>
        </div>
      </div>
      <div class="container web-section">
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="webpage-section-header  text-center" >
              Contact Us
            </div>
            <div class="place-bottom-container">
              <i class="fas fa-map-marker"></i> <a :href="'http://maps.google.com/?q=' + merchantItem.address" target="_blank" >{{merchantItem.address}}</a>
              <br>
              <i class="fas fa-phone"></i> <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
              <!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
            </div>
          </div>
          <div class="col-12 col-md-4">
            <!--                <div class="round-box" style="margin:auto;">-->
            <div class="webpage-section-header text-center">
              Opening Hours
            </div>
            <div class="body">
              <table>
                <tr v-for="(day, di) in openingTime">
                  <td style="width: 50%; vertical-align: top;">{{day.dayString}}</td>

                  <td style="width: 50%; vertical-align: top; text-align: left;">
                    <template v-if="day.open==false">
                      Closed
                    </template>
                    <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                      <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>

                    </template>
                  </td>

                </tr>
              </table>
            </div>
            <!--                </div>-->
          </div>
          <div class="col-12 col-md-4">
            <div class="webpage-section-header  text-center">
              Location
            </div>
            <div style="height: 300px;" id="mapName">
              <iframe :src="merchantItem.webSetting.googleMap" width="100%" height="100%" frameborder="0" style="border:0"
                      allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%; background-color: #ccc; margin-top:20px;">
        <div class="container">
          <div class="row" style="padding-top:10px;padding-bottom: 50px;">
            <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">
              <a v-if="merchantItem.webSetting.facebook !== null && (merchantItem.webSetting.facebook.startsWith('https://facebook.com') || merchantItem.webSetting.facebook.startsWith('https://www.facebook.com'))"
                 :href="merchantItem.webSetting.facebook" target="_blank">
                <i class="fab fa-facebook"></i>
              </a>
            </div>
            <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">
              <a v-if="merchantItem.webSetting.instagram !== null && (merchantItem.webSetting.instagram.startsWith('https://www.instagram.com') || merchantItem.webSetting.instagram.startsWith('https://instagram.com'))"
                 :href="merchantItem.webSetting.instagram" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
            </div>

            <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">
              <a v-if="merchantItem.webSetting.youtube !== null && (merchantItem.webSetting.youtube.startsWith('https://www.youtube.com') || merchantItem.webSetting.youtube.startsWith('https://youtube.com'))"
                 :href="merchantItem.webSetting.youtube" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </div>
            <!--              <div class="col-6 col-md-2" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
            <!--                <i class="fab fa-tiktok"></i>-->
            <!--              </div>-->
            <div class="col-12 col-md-6 text-left" style="font-size: small; display: flex;">
              <div style="width: 120px;">
                <img style="width:100px;" :src="merchantItem.webSetting.icon"/>
              </div>
              <div style="width: calc(100% - 150px);">
<!--                <template v-if="merchantItem.registeredTitle != undefined && merchantItem.registeredTitle != null && merchantItem.registeredTitle.length > 0">-->
<!--                  <strong>{{merchantItem.registeredTitle}}</strong><br>trade as-->
<!--                </template>-->
                <strong>{{merchantItem.title}}</strong><br>{{merchantItem.contact}}<br><span v-html="merchantItem.address.replace(/\n/g, '<br />')"></span>
              </div>

            </div>

            <!--              <div class="col-6 text-left tnc-btn" style="font-size:  x-small">-->
            <!--                <span v-on:click="openTnc">Terms & Conditions</span>-->
            <!--              </div>-->

            <div class="col-12" style="font-size:  small; margin-top:20px;">
              Copyright @2021 <strong>{{merchantItem.title}}</strong>. All rights reserved
            </div>
            <!--              <div class="col-12" style="font-size:  x-small">-->
            <!--                Powered by <strong><span v-if="isEemo">EEMO & GOMO</span><span v-else>Show Me The Menu</span></strong>-->
            <!--                <template v-if="isEemo==false"><br>Borium Studio Limited</template>-->
            <!--              </div>-->

          </div>
        </div>
      </div>
    </template>
    <div v-else>
      Cannot find restaurant for booking
    </div>
  </div>
</template>

<script>
import {getMerchant, getMerchantUrl} from "../api/borium";
import {isPlatformHost} from "../api/hosts";

    import BookingView from "./BookingView";
    import BookingTableView from "./BookingTableView.vue";
    import {Slider, SliderItem} from "vue-easy-slider";
    export default {
      name: "Booking",
      data() {
        return {
          merchantItem:false,
          openingTime:[],
          bookingType:-1,
        }
      },
      components: {
        Slider,
        SliderItem,
        BookingView,
        BookingTableView,
      },
      created() {
      },
      mounted() {
        this.updatePage();
      },
      beforeDestroy() {
      },
      destroyed() {
      },
      methods: {
        updatePage: function() {
          // this.getMerchantWithUrl('https://jumak39.co.uk');
          // return;
          // console.log("get with id");
          let merchantId = 0;
          if(this.$route.params.hasOwnProperty('id')) {
            merchantId = this.$route.params.id;
          } else if(this.$route.query.hasOwnProperty('id')) {
            merchantId = this.$route.query.id;
          } else if(!isPlatformHost()) {
            let url = 'https://' + window.location.host;
            this.getMerchantWithUrl(url);
            return;
          } else {

            return;
          }

          // console.log("shop id " + merchantId);
          let self = this;
          getMerchant(merchantId)
          .then(function(data) {
            // console.log(data);
            if(data.success) {
              if(data.item.webSetting !== undefined && data.item.webSetting !== null) {
                if(data.item.webSetting.imageUrls !== undefined && data.item.webSetting.imageUrls !== null && data.item.webSetting.imageUrls.length > 0) {
                  data.item.webSetting.imageUrls = data.item.webSetting.imageUrls.split(",");
                } else {
                  data.item.webSetting.menuImages = [];
                }
                if(data.item.webSetting.menuImages !== undefined && data.item.webSetting.menuImages !== null && data.item.webSetting.menuImages.length > 0) {
                  data.item.webSetting.menuImages = data.item.webSetting.menuImages.split(",");
                } else {
                  data.item.webSetting.menuImages = [];
                }
              }
              self.$data.bookingType = parseInt(data.item.tableBooking);
              self.$data.merchantItem = data.item;
              if(self.$data.merchantItem.openingTime != null && self.$data.merchantItem.openingTime.length > 3) {
                self.$data.openingTime = JSON.parse(self.$data.merchantItem.openingTime);
              }
              // console.log(self.$data.merchantItem);
              // self.setMerchant();
              self.setPageMeta();
            }
          })
          .catch(function(err) {
            // console.log(err);
          })
        },
        getMerchantWithUrl: function(url) {
          let self = this;
          getMerchantUrl(url)
            .then(function(data) {
              if(data.success) {
                if(data.item.webSetting !== undefined && data.item.webSetting !== null) {
                  if(data.item.webSetting.imageUrls !== undefined && data.item.webSetting.imageUrls !== null && data.item.webSetting.imageUrls.length > 0) {
                    data.item.webSetting.imageUrls = data.item.webSetting.imageUrls.split(",");
                  } else {
                    data.item.webSetting.menuImages = [];
                  }
                  if(data.item.webSetting.menuImages !== undefined && data.item.webSetting.menuImages !== null && data.item.webSetting.menuImages.length > 0) {
                    data.item.webSetting.menuImages = data.item.webSetting.menuImages.split(",");
                  } else {
                    data.item.webSetting.menuImages = [];
                  }
                }
                self.$data.bookingType = parseInt(data.item.tableBooking);
                self.$data.merchantItem = data.item;
                if(self.$data.merchantItem.openingTime != null && self.$data.merchantItem.openingTime.length > 3) {
                  self.$data.openingTime = JSON.parse(self.$data.merchantItem.openingTime);
                }
                // console.log(self.$data.merchantItem);
                // self.setMerchant();
                self.setPageMeta();
              }
            })
            .catch(function(err) {
              // console.log(err);
            })

        },
        setPageMeta: function() {
          const titleEl = document.querySelector('head title');
          const descEl = document.querySelector('head meta[name="description"]');
          const keywordsEl = document.querySelector('head meta[name="keywords"]');

          let title =this.$data.merchantItem.title;
          let key = this.$data.merchantItem.title;

          let description = "Simple click and collect order for " + this.$data.merchantItem.title;
          if(this.$data.merchantItem.region !== undefined && this.$data.merchantItem.region != null && this.$data.merchantItem.region.length > 0) {
            title += " in " + this.$data.merchantItem.region;
            key += "," + this.$data.merchantItem.region;
            description += " in " + this.$data.merchantItem.region;
          }
          key += ", takeaway, delivery";
          if(this.$data.merchantItem.tags !== undefined && this.$data.merchantItem.tags != null && this.$data.merchantItem.tags.length > 0) {
            key += "," + this.$data.merchantItem.tags;
          }
          title += " Reservation | Table Booking | Takeaway | Menu | Price | Show Me The Menu";
          titleEl.textContent = title;

          descEl.setAttribute('content', description);
          keywordsEl.setAttribute('content', key);
          if(this.$data.merchantItem.webSetting !== undefined
            && this.$data.merchantItem.webSetting != null
            && this.$data.merchantItem.webSetting.icon != null
            && this.$data.merchantItem.webSetting.icon.startsWith("https://")) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = this.$data.merchantItem.webSetting.icon;
          }
        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Booking.vue